import styled from 'styled-components'
import { media } from 'utils/styleUtils'
import { DOVE_GRAY, PAGAMO_RED, WHITE } from 'constants/colors'
import Search from './Icons/Search'

export const Form = styled.form`
  width: 100%;
  height: 40px;
  border-radius: 5px;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.4);
  display: flex;
  overflow: hidden;

  ${media.pad} {
    margin: 0 auto;
    width: 60%;
  }
`

export const Input = styled.input`
  padding-left: 0.5rem;
  height: 100%;
  border: none;
  outline: none;
  background-color: ${WHITE};
  color: ${DOVE_GRAY};
  font-size: 20px;
  font-weight: 300;
  flex: 1 0 auto;
`

export const SubmitBtn = styled.button.attrs({
  type: 'submit',
})`
  padding: 0;
  width: 40px;
  border: none;
  outline: none;
  background-color: ${PAGAMO_RED};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  ${media.mobileLandscape} {
    width: 65px;
  }
`
SubmitBtn.Img = Search
